import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const offers = [{
  title: 'Cursuri Individuale',
  subtitle: 'Un singur curs, la alegerea ta',
  benefits: ['Alegi cursul care te interesează cel mai mult', 'Acces pe viață la cursul ales', 'Meditații ghidate și exerciții practice incluse', 'Parcurgi totul în ritmul tău', 'Ideal dacă vrei să începi cu un singur pas'],
  cta: 'Vezi Cursurile Disponibile',
  href: 'https://academiadeabundenta.ro/magazin',
  image: 'https://cdn.magicpatterns.com/uploads/nQxQRNuxc8ZhTi2XgiQii3/bcul_prosperitatii_detaliu.png',
  imageAlt: 'Cheie aurie pe hartă veche — alegerea unui drum personal',
  isPopular: false
}, {
  title: 'Colecția de cursuri "Academia de Abundență"',
  subtitle: 'Toate cele 6 cursuri într-un singur program — alegi între Standard și Premium în funcție de nevoile tale',
  benefits: ['Acces la toate cele 6 cursuri online — pe viață', 'Plan Standard: cursuri + 24 întâlniri săptămânale de grup (6 luni)', 'Plan Premium: tot Standard + 6 sesiuni 1:1 + 6 ședințe Theta Healing®', 'Plan Premium include și un retreat de weekend cu Adrian', 'Reduceri exclusive la cursurile și workshopurile viitoare'],
  cta: 'Vreau colecția de cursuri!',
  href: 'https://academiadeabundenta.ro/colectie',
  image: 'https://cdn.magicpatterns.com/uploads/gsaRBSS7ZT9YCg7jgp4iQr/academia_abundentei_program_complet.png',
  imageAlt: 'Poartă aurie cu cărți — programul complet Academia de Abundență',
  isPopular: true
}, {
  title: 'Terapie 1 la 1 Theta Healing®',
  subtitle: 'Sesiuni individuale personalizate, online cu Adrian',
  benefits: ['Lucrăm direct pe blocajele tale specifice', 'Identificăm și transformăm credințele limitative din subconștient', 'Tehnica Theta Healing® aplicată personalizat pe situația ta', 'Poți alege o sesiune individuală sau un pachet de 6', 'Ideal când vrei rezultate profunde și rapide'],
  cta: 'Vezi Detaliile 1 la 1',
  href: 'https://wa.me/40726042604',
  image: 'https://cdn.magicpatterns.com/uploads/fxLQ4fEBHR6npdmMZaN4aX/sesiuni_theta_healing.png',
  imageAlt: 'Două mâini cu energie aurie și mov — sesiuni Theta Healing®',
  isPopular: false
}];
export function OffersSection() {
  return <section id="programe" className="py-20 lg:py-32 bg-white" data-id="element-1843">
      <div className="max-w-7xl mx-auto px-6" data-id="element-1844">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16 lg:mb-24" data-id="element-1845">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-brand-text mb-6" data-id="element-1846">
            Modalități de a lucra cu mine
          </h2>
          <div className="h-[2px] w-16 bg-brand-gold mx-auto rounded-full mb-6" data-id="element-1847" />
          <p className="font-subtitle text-lg md:text-xl text-brand-textSec" data-id="element-1848">
            Alege formatul care ți se potrivește pentru călătoria ta spre
            abundență.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-3 gap-8 items-stretch" data-id="element-1849">
          {offers.map((offer, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className={`relative flex flex-col bg-brand-cream rounded-3xl overflow-hidden shadow-warm hover:shadow-warm-hover transition-all duration-300 hover:-translate-y-2 border-2 border-brand-gold/40 ${offer.isPopular ? 'lg:-mt-4 lg:mb-[-16px] ring-2 ring-brand-gold/60' : ''}`} data-id="element-1850">
              {/* Image at top of card */}
              <div className="w-full h-48 overflow-hidden bg-brand-cream" data-id="element-1851">
                <img src={offer.image} alt={offer.imageAlt} className="w-full h-full object-cover" data-id="element-1852" />
              </div>

              {/* Popular badge */}
              {offer.isPopular && <div className="absolute top-4 right-4 bg-brand-gold text-brand-cream text-xs font-heading font-bold px-4 py-1.5 rounded-full uppercase tracking-wider shadow-md" data-id="element-1853">
                  Recomandat
                </div>}

              <div className="p-8 lg:p-10 flex-grow flex flex-col" data-id="element-1854">
                <h3 className="font-heading font-bold text-2xl text-brand-text mb-2" data-id="element-1855">
                  {offer.title}
                </h3>
                <p className="font-subtitle text-brand-textSec mb-8 min-h-[48px]" data-id="element-1856">
                  {offer.subtitle}
                </p>

                <ul className="space-y-4 mb-10 flex-grow" data-id="element-1857">
                  {offer.benefits.map((benefit, i) => <li key={i} className="flex items-start gap-3" data-id="element-1858">
                      <div className="w-5 h-5 rounded-full bg-brand-gold/20 flex items-center justify-center shrink-0 mt-0.5" data-id="element-1859">
                        <Check className="w-3 h-3 text-brand-gold" strokeWidth={3} data-id="element-1860" />
                      </div>
                      <span className="text-brand-textSec text-lg leading-relaxed" data-id="element-1861">
                        {benefit}
                      </span>
                    </li>)}
                </ul>

                <a href={offer.href} target="_top" className={`w-full text-center font-heading font-semibold px-6 py-4 rounded-xl transition-colors duration-300 shadow-md ${offer.isPopular ? 'bg-brand-gold text-brand-cream hover:bg-brand-purple' : 'bg-brand-purple text-brand-cream hover:bg-brand-text'}`} data-id="element-1862">
                  {offer.cta}
                </a>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}